var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioPreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 74,
    viewBox: "0 0 100 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 74,
    rx: 3,
    fill: "#888FA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0442 38.8428C42.212 38.8428 43.3167 39.1766 44.232 39.7646V26.8605V24H47.0726H62.1594H65V26.8605V44.9135C65 48.2825 62.3014 51 58.9716 51C55.6418 51 52.9274 48.2825 52.9274 44.9135C52.9274 41.5603 55.6418 38.8428 58.9716 38.8428C60.1394 38.8428 61.2441 39.1766 62.1594 39.7646V26.8605H47.0726V44.9135C47.0726 48.2825 44.374 51 41.0442 51C37.7144 51 35 48.2825 35 44.9135C35 41.5603 37.7144 38.8428 41.0442 38.8428V38.8428Z",
    fill: "#CDD1DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPreview);
export default __webpack_public_path__ + "static/media/audio-preview.e2289601a3197f0f0b48d614dae853ec.svg";
export { ForwardRef as ReactComponent };